export default __webpack_public_path__ + "static/media/sk.4bd13610.png";